const trimEndSlashes = (s) => String(s || '').replace(/\/+$/, '');

const DEFAULT_PUBLIC_ORIGIN = 'https://genododi.local:5174';
const DEFAULT_CLINIC_ORIGIN = 'https://genododi.github.io/drmahmoud';

/** Clinic business line for welcome WhatsApp / SMS (E.164). */
export const CLINIC_BUSINESS_PHONE = '+201005602267';
export const CLINIC_BUSINESS_PHONE_DISPLAY = '01005602267';

/**
 * Absolute origin of this EMR app (no trailing slash). Used for OG/meta and
 * defaults when `window` is unavailable (SSR/build).
 */
export const getPublicAppOrigin = () => {
    const v = import.meta.env.VITE_PUBLIC_URL;
    if (v) return trimEndSlashes(v);
    if (typeof window !== 'undefined' && window.location?.origin) {
        return trimEndSlashes(window.location.origin);
    }
    return DEFAULT_PUBLIC_ORIGIN;
};

/**
 * Patient-facing clinic site (GitHub Pages or another host). Trailing slash URL.
 */
export const getClinicWebsiteBase = () => {
    const v = import.meta.env.VITE_CLINIC_WEBSITE_URL;
    const origin = v ? trimEndSlashes(v) : DEFAULT_CLINIC_ORIGIN;
    return `${origin}/`;
};

/** `https://host/path/portal.html` */
export const getPortalHtmlUrl = (hash = '') => {
    const base = trimEndSlashes(getClinicWebsiteBase());
    return `${base}/portal.html${hash || ''}`;
};

export const getPortalHtmlUrlForPatient = (patientId) =>
    getPortalHtmlUrl(`#id=${encodeURIComponent(patientId)}`);

/** Short label for tooltips, e.g. `genododi.github.io/drmahmoud` */
export const getClinicWebsiteLabel = () => {
    try {
        const u = new URL(getClinicWebsiteBase());
        const path = u.pathname.replace(/^\//, '').replace(/\/$/, '');
        return path ? `${u.host}/${path}` : u.host;
    } catch {
        return 'genododi.github.io/drmahmoud';
    }
};
